// Configuration file to load environment variables
// This file should be included before script.js in the HTML

// Load environment variables from window.env (if available) or use defaults
const config = {
    supabaseUrl: window.env?.SUPABASE_URL || 'https://edehkbxxjjjenijufatq.supabase.co',
    supabaseAnonKey: window.env?.SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVkZWhrYnh4ampqZW5panVmYXRxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTkyMDY4OTEsImV4cCI6MjA3NDc4Mjg5MX0.SLAD7TRf8XkYUvrnnqtHkAhu8YAJ_JrQMf6f8tLS5m8'
};

// Make config available globally
window.appConfig = config;
